import { Component, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { getAuth, onAuthStateChanged, signOut } from 'firebase/auth';
import { User } from '../interfaces';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { Router } from '@angular/router';
import { db } from '../app.component';
import { MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatSelect, MatOption } from '@angular/material/select';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-selecting-organisation',
  templateUrl: './selecting-organisation.component.html',
  styleUrls: ['./selecting-organisation.component.scss'],
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatSelect,
    MatOption,
    MatDialogActions,
    MatButton,
  ],
})
export class SelectingOrganisationComponent implements OnInit {
  userData: User;
  organisationsForm: UntypedFormGroup;
  organisations: any;
  constructor(
    private fb: UntypedFormBuilder,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.organisationsForm = this.fb.group({
      organisationId: [, Validators.required],
    });

    onAuthStateChanged(getAuth(), async (user) => {
      if (user) {
        this.userData = {
          ...((await getDoc(doc(db, `users/${user.uid}`))).data() as User),
          id: `${user.uid}`,
        };

        this.organisations = this.userData.organisations.filter((org) => {
          return org.roles && org.roles.length > 0;
        });
      }
    });
  }

  async selectOrg() {
    const orgId = this.organisationsForm.value.organisationId;
    await setDoc(
      doc(db, `users`, `${this.userData.id}`),
      {
        selectedOrgId: orgId,
      },
      { merge: true },
    );
    this.router.navigate([`/set/${orgId}`]);
  }

  signOutBackToLogin() {
    signOut(getAuth())
      .then(() => {
        return this.router.navigate(['/login']);
      })
      .catch((error) => {
        console.log('logoutError', error);
      });
  }
}
